import React, { memo, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import Modal from 'react-modal';
import isObjectEmpty from '../../../../../aem-core-components/utils/isObjectEmpty';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents';
import { VARIABLE_CONFIG } from '../../../../../constants/analyticsConstants/Variables';
import { MEDIA_TYPE } from '../../../../../constants/screenConstants';
import useMedia from '../../../../../hooks/useMedia';
import { usePageType } from '../../../../../hooks/usePageType';
import FilterGreen from '../../../../../resources/images/filtergreen.svg';
import Button from '../../../../global/atoms/button';
import FilterFooter from '../../../../global/modules/checkboxFilters/FilterFooter';
import FilterHeader from '../../../../global/modules/checkboxFilters/FilterHeader';
import SelectedFilter from '../../../../global/modules/checkboxFilters/SelectedFilter';
import { logError } from '../../../../global/utils/logger';
import { FACET_TYPES } from '../../../hooks/useSearchUtils';
import CategoryFacet from '../categoryFacet/CategoryFacet';
import './searchfilter.scss';
import SearchFilters from './SearchFilters';

function SearchFiltersMulti(props) {
    const {
        facetControllerList,
        categoryFacet,
        controllerConfig,
        title,
        filterTitleClass,
        filterBodyClasess,
        isCategoryFacetVisible,
        triggerEvents,
        presetFacet,
        queryState,
        setHasFacets
    } = props;
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [filterModalOpen, setFilterModalOpen] = useState(false); //TODO ashish
    const [filterData, setFilterData] = useState({});
    const [catFacetState, setCatFacetState] = useState();

    const [viewResultsCount, setViewResultsCount] = useState(0);
    const [selectedFilterCount, setSelectedFilterCount] = useState(0);
    const [isSticky, setIsSticky] = useState(false);
    const intl = useIntl();
    const mediaType = useMedia();
    const customStyle = { overlay: { background: 'rgba(0,0,0,0.4)' }, content: { padding: '0px' } };
    const mobileFilterRef = useRef(null);
    const pageType = usePageType();
    const { sendEventsForClick } = useAnalyticsContext();

    useEffect(() => {
        Modal.setAppElement('.root');
    }, []);

    useEffect(() => {
        if (facetControllerList?.length > 0 && controllerConfig?.length > 0) {
            let filterData = {};
            facetControllerList?.map((controller, index) => {
                const { facetId } = controller.state
                filterData[facetId] = {
                    selectedOptions: getPreselectOptions(controller),
                    facetId: facetId,
                    type: controllerConfig?.find(item => item?.key === facetId)?.type
                };
                controller.subscribe(() => getResultQty());
            });
            if (filterData?.categoryl3?.selectedOptions?.length > 0) {
                setHasFacets(true);
            } else {
                setHasFacets(false);
            }
            setFilterData(filterData);
        }
    }, [facetControllerList, controllerConfig]);

    useEffect(() => {
        if (filterModalOpen) {
            mobileFilterRef.current?.addEventListener('scroll', handleIsSticky);
        } else {
            mobileFilterRef.current?.removeEventListener('scroll', handleIsSticky);
        }
    }, [filterModalOpen]);

    useEffect(() => {
        const body = document.querySelector('body');
        const liveChatButton = document.querySelector('.chat-button');
        if (isFilterModalOpen) {
            body.classList.add('overflow-hidden');
            if (liveChatButton) {
                liveChatButton.ariaHidden = 'true';
                liveChatButton.tabIndex = '-1';
            }
        } else {
            body.classList.remove('overflow-hidden');
            if (liveChatButton) {
                liveChatButton.ariaHidden = 'false';
                liveChatButton.tabIndex = '0';
            }
        }
    }, [isFilterModalOpen]);

    useEffect(() => {
        getSelectedFilterCount();
    }, [filterData, facetControllerList]);

    const handleIsSticky = e => {
        const scrollTop = mobileFilterRef.current.scrollTop;
        scrollTop >= 10 ? setIsSticky(true) : setIsSticky(false);
    };

    const handleFilterModal = () => {
        try {
            sendEventsForClick(
                VARIABLE_CONFIG.EVENT.UAEVENT,
                VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                `filter ${pageType}`,
                VARIABLE_CONFIG.EVENT_ACTION.FILTER_ICON_CLICK,
                VARIABLE_CONFIG.EVENT_LABEL.FILTER_ICON
            );
        } catch (error) {
            logError(error, false, 'handleFilterModal');
        }
        setIsFilterModalOpen(prev => !prev);
    };
    const afterOpenModal = () => {
        setFilterModalOpen(!filterModalOpen);
    };
    const handleModalClose = () => {
        if (viewResultsCount === 0 || isNaN(viewResultsCount)) {
            try {
                sendEventsForClick(
                    VARIABLE_CONFIG.EVENT.UAEVENT,
                    VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                    `filter ${pageType}`,
                    VARIABLE_CONFIG.EVENT_ACTION.SELECT,
                    VARIABLE_CONFIG.EVENT_LABEL.CLOSE_FILTERS
                );
            } catch (error) {
                logError(error, false, 'handleModalClose');
            }
        } else {
            let subCategory = '';
            facetControllerList?.forEach(contr => {
                contr?.state?.values?.forEach(item => {
                    if (item?.state === 'selected') {
                        subCategory = subCategory + ' ' + item?.value + '(' + item?.numberOfResults + ')';
                    }
                });
            });
            try {
                sendEventsForClick(
                    VARIABLE_CONFIG.EVENT.UAEVENT,
                    VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                    `filter ${pageType}`,
                    `view ${viewResultsCount} results`,
                    `category::${subCategory}`
                );
            } catch (error) {
                logError(error, false, 'handleModalClose');
            }
        }
        setIsFilterModalOpen(prev => !prev);
    };

    const getResultQty = () => {
        let qty = 0;
        facetControllerList.forEach(contr => {
            contr.state.values.forEach(item => {
                if (item.state === 'selected') {
                    qty += item.numberOfResults;
                }
            });
        });
        if (isCategoryFacetVisible && !isObjectEmpty(categoryFacet)) {
            qty += categoryFacet?.state?.parents[categoryFacet?.state?.parents.length - 1]?.numberOfResults;
        }
        setViewResultsCount(qty);
    };

    const getSelectedFilterCount = () => {
        let count = 0;
        Object.keys(filterData)?.forEach((item, index) => {
            count += filterData[item]?.selectedOptions.length;
        });
        setSelectedFilterCount(count);
    };

    const getPreselectOptions = (controller) => {
        if (presetFacet) {
            return presetFacet(controller) || []
        }
        return controller?.state?.values?.filter(item => item.state !== "idle")?.map(item => item.value) || []
    }

    const renderFilters = () => {
        return facetControllerList?.map((controller, index) => {
            if (controller.state.values.length > 0) {
                //TODO create a switch case for rendering diffrernt types
                const controllerConfigVal = controllerConfig.find(facet => facet.key === controller.state.facetId)
                if (controllerConfigVal?.type === FACET_TYPES.NUMERIC_RANGE) {
                    let allItemsZero = controller.state.values.every(item => item.numberOfResults === 0 || (item.start===0 && item.end===0));
                    if (allItemsZero) {
                        return null
                    }
                }
                return (
                    <React.Fragment key={`${controller?.state?.facetId}${index}`}>
                        <SearchFilters
                            title={index === 0 ? 'Filter' : ''}
                            subFilter={{
                                label: controllerConfigVal?.label,
                                key: controller.state.facetId,
                                type: controllerConfigVal?.type,
                            }}
                            filterTitleClass={'plp__filter-title'}
                            filterBodyClasess={'asdf'}
                            controller={controller}
                            filterData={filterData}
                            setFilterData={setFilterData}
                            triggerEvents={triggerEvents}
                            presetFacet={presetFacet}
                        />
                    </React.Fragment>
                );
            } else return null;
        });
    };
    return (
        <>
            <Button
                onClick={handleFilterModal}
                type="button"
                className="button button-outline-primary button-square plp__right-filter-button searchfilter-button"
                customButtonAriaLabel={intl.formatMessage({ id: 'location:filter-text' })}>
                <FilterGreen />
            </Button>
            <span className={`filter__count ${selectedFilterCount > 0 && 'filter__count_selected'}`}>
                {intl.formatMessage({ id: 'location:filter-text' })}{' '}
                {selectedFilterCount > 0 && (<span>{selectedFilterCount}</span>)}
            </span>
            {mediaType !== MEDIA_TYPE.DESKTOP ? (
                <Modal
                    role="dialog"
                    isOpen={isFilterModalOpen}
                    style={customStyle}
                    className="mobile-filter"
                    onRequestClose={handleModalClose}
                    onAfterOpen={afterOpenModal}>
                    <div className="mobile-filter__wrap" ref={mobileFilterRef}>
                        <FilterHeader
                            title={title}
                            filterTitleClass={`${filterTitleClass} mobile-filter__title ${isSticky ? 'mobile-filter__title-sticky' : ''
                                }`}
                            onCloseHandler={handleModalClose}
                            showCloseButton={true}
                            facetControllerList={facetControllerList}
                            filterData={filterData}
                            setFilterData={setFilterData}
                        />

                        <div
                            className={`${mediaType === MEDIA_TYPE.DESKTOP ? 'filter__body' : 'mobile-filter__body'
                                } ${filterBodyClasess}`}>
                            <SelectedFilter
                                filterData={filterData}
                                setFilterData={setFilterData}
                                facetControllerList={facetControllerList}
                                categoryFacet={categoryFacet}
                                queryState={queryState}
                            />
                            {isCategoryFacetVisible && (
                                <CategoryFacet catFacetState={catFacetState} setCatFacetState={setCatFacetState} />
                            )}
                            {renderFilters()}
                        </div>
                        <FilterFooter onClose={handleModalClose} resultQty={viewResultsCount} />
                    </div>
                </Modal>
            ) : (
                <>
                    <FilterHeader
                        title={title}
                        filterTitleClass={filterTitleClass}
                        onCloseHandler={handleModalClose}
                        showCloseButton={false}
                        facetControllerList={facetControllerList}
                        filterData={filterData}
                        setFilterData={setFilterData}
                    />
                    <div
                        className={`${mediaType === MEDIA_TYPE.DESKTOP ? 'filter__body' : 'mobile-filter__body'
                            } ${filterBodyClasess}`}>
                        <SelectedFilter
                            filterData={filterData}
                            setFilterData={setFilterData}
                            facetControllerList={facetControllerList}
                            categoryFacet={categoryFacet}
                            queryState={queryState}
                        />
                        {isCategoryFacetVisible && (
                            <CategoryFacet catFacetState={catFacetState} setCatFacetState={setCatFacetState} />
                        )}
                        {renderFilters()}
                    </div>
                </>
            )}
        </>
    );
}

export default memo(SearchFiltersMulti);

SearchFiltersMulti.defaultProps = {
    isCategoryFacetVisible: false,
    categoryFacet: {},
    triggerEvents: false,
    presetFacet: () => {
        return [];
    },
    queryState: {},
    setHasFacets: () => {}
};
